<script setup>
import { ref, onMounted } from "vue";
import MiniStatisticsCard from "@/examples/Cards/MiniStatisticsCard.vue";
import GradientLineChart from "@/examples/Charts/GradientLineChart.vue";
import Carousel from "./components/Carousel.vue";
import api from "@/services/apiService"; 
// import {  useRouter } from "vue-router"; 

const stats = ref({
  houses: 0,
  users: 0,
  contacts: 0,
  blogs: 0,
});
// const router = useRouter(); 

const houseChartData = ref({
  labels: [],
  datasets: [
    {
      label: "Nuevas Propiedades",
      data: [],
    },
  ],
});

const fetchStats = async () => {
  try {
    const { data } = await api.get("/statistics");
    stats.value = data;
  } catch (error) {
    console.error("Error loading statistics:", error);
  }
};

const fetchChart = async () => {
  try {
    const { data } = await api.get("/charts/houses-monthly");
    houseChartData.value.labels = data.labels;
    houseChartData.value.datasets[0].data = data.data;
  } catch (error) {
    console.error("Error loading chart data:", error);
  }
};

onMounted(() => {
 
      fetchStats();
      fetchChart();    }
 
);


</script>

<template>
  <div class="py-4 container-fluid">
    <div class="row">
      <div class="col-lg-12">
        <!-- Statistics -->
        <div class="row">
          <div class="col-lg-3 col-md-6 col-12">
            <mini-statistics-card title="Total Casas" :value="stats.houses" description="Publicado en la plataforma"
              :icon="{
                component: 'ni ni-building',
                background: 'bg-gradient-primary',
                shape: 'rounded-circle',
              }" />
          </div>
          <div class="col-lg-3 col-md-6 col-12">
            <mini-statistics-card title="Total Usuarios" :value="stats.users" description="Usuarios registrados" :icon="{
              component: 'ni ni-single-02',
              background: 'bg-gradient-info',
              shape: 'rounded-circle',
            }" />
          </div>
          <div class="col-lg-3 col-md-6 col-12">
            <mini-statistics-card title="Total Contactos" :value="stats.contacts" description="Consultas recibidas"
              :icon="{
                component: 'ni ni-chat-round',
                background: 'bg-gradient-success',
                shape: 'rounded-circle',
              }" />
          </div>
          <div class="col-lg-3 col-md-6 col-12">
            <mini-statistics-card title="Total Blogs" :value="stats.blogs" description="Artículos publicados" :icon="{
              component: 'ni ni-books',
              background: 'bg-gradient-warning',
              shape: 'rounded-circle',
            }" />
          </div>
        </div>

        <!-- Chart + Carousel -->
        <div class="row">
          <div class="col-lg-7 mb-lg">
            <div class="card z-index-2">
              <gradient-line-chart v-if="houseChartData.labels.length > 0 && houseChartData.datasets[0].data.length > 0"
                id="chart-line" title="Nuevas Propiedades por Mes"
                description="Cantidad de propiedades añadidas por mes" :chart="houseChartData" />

            </div>
          </div>
          <div class="col-lg-5">
            <carousel />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
